import { render, staticRenderFns } from "./SamAccordion.vue?vue&type=template&id=624376fc&scoped=true&"
import script from "./SamAccordion.vue?vue&type=script&lang=js&"
export * from "./SamAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SamAccordion.vue?vue&type=style&index=0&id=624376fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624376fc",
  null
  
)

export default component.exports